import React from "react";
import PropTypes from "prop-types";
import { StandaloneSearchBox } from "@react-google-maps/api";

const AddressAutocomplete = ({ setAddress, children }) => {
  const searchBoxRef = React.useRef(null);
  const inputWrapperRef = React.useRef(null);

  const onLoad = (ref) => {
    searchBoxRef.current = ref;

    // Wait for pac-container to appear in DOM, then move it inside our wrapper
    const observer = new MutationObserver(() => {
      const pac = document.querySelector(".pac-container");
      if (pac && inputWrapperRef.current && !inputWrapperRef.current.contains(pac)) {
        inputWrapperRef.current.appendChild(pac);
        pac.style.position = "absolute";
        // pac.style.top = "100%";
        // pac.style.left = "0";
        pac.style.width = "100%"; // always match input width
      }
    });

    observer.observe(document.body, { childList: true });
  };

  const onPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      setAddress(places[0]);
    }
  };

  return (
    <div ref={inputWrapperRef} style={{ position: "relative", width: "100%" }}>
      <StandaloneSearchBox onLoad={onLoad} onPlacesChanged={onPlacesChanged}>
        {children}
      </StandaloneSearchBox>
    </div>
  );
};

AddressAutocomplete.propTypes = {
  setAddress: PropTypes.func,
  children: PropTypes.node,
};

export default AddressAutocomplete;
